module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-3_BW2-p-2000-684dd0858035dea74ded81dd89927380.jpg";